import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=237b79cd&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=237b79cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237b79cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237b79cd')) {
      api.createRecord('237b79cd', component.options)
    } else {
      api.reload('237b79cd', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=237b79cd&scoped=true&", function () {
      api.rerender('237b79cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vug0To52u0oP/JS/comp/PopupDialog.vue"
export default component.exports